/**
 * Nieuws configuratie voor de premium landing page.
 *
 * Gebruik:
 * - Zet `active: true` om het nieuws te tonen
 * - Zet `active: false` om de standaard missie-tekst te tonen
 */

interface NewsConfig {
  active: boolean;
  badge: string;
  title: string;
  message: string;
  footer: string;
}

export const newsConfig: NewsConfig = {
  active: true,

  badge: "Nieuw",
  title: "Krijg feedback op je uitwerking in het WisWiz-schrift op iPad",
  message:
    "Heb jij een iPad met Pencil? Maak dan je opgaven in het WisWiz-schrift op iPad. Terwijl jij je uitwerking maakt, leest WisWiz meteen mee. Daarna helpen we je verder of kijken we je werk na. Download de WisWiz iPad-app en probeer het zelf!",
  footer: ""
};
